import { FC } from "react"
import { Equipment, Site } from "../../../generated/proto-ts/main"

export const SiteEquipmentsTable_AB: FC<{
  equipments: Equipment[] | null
  siteUUID: Site["uuid"] | null
}> = ({ equipments, siteUUID }) => {
  return <>Site Equipments Table for EN 14960 - AIRBAGS</>
}
